var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrialpackGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 166,
    viewBox: "0 0 142 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41357 57.5913C6.41357 57.5913 6.54013 132.45 8.24866 135.235C9.95719 138.019 71.3377 166.115 73.5525 165.482L73.1728 85.3707L6.41357 57.5913Z",
    fill: "#E54242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7002 146.498C29.7002 146.498 35.1422 154.598 47.1019 154.598V79.1059L29.7002 71.1328V146.498Z",
    fill: "#FFAE1F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1019 91.6984V79.1059L29.7002 71.1328V86.7627C35.4586 88.5978 41.217 90.3063 47.1019 91.6984Z",
    fill: "#FFAE1F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5399 85.6871L73.5524 165.482C73.5524 165.482 133.161 136.563 133.731 133.526C134.3 130.489 135.882 54.6172 135.882 54.6172L72.5399 85.6871Z",
    fill: "#C13838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.636 152.067C100.636 152.067 111.077 150.864 116.329 143.967L118.101 69.1079L100.32 74.4866L100.636 152.067Z",
    fill: "#EF9926"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.595 90.686L118.101 69.1079L100.32 74.4866L100.446 96.8873C106.204 94.989 111.963 92.9008 117.595 90.686Z",
    fill: "#EF9926"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.528631 47.0869C0.528631 47.0869 0.0223879 64.0457 0.655177 66.3237C1.35124 68.6017 74.8813 98.9123 76.4633 99.5451C76.4633 99.5451 76.0203 78.9795 75.9571 78.1568C75.9571 77.1444 0.528631 47.0869 0.528631 47.0869Z",
    fill: "#EF4B4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.957 78.1572L76.4633 99.5455C76.4633 99.5455 139.362 73.9808 140.312 70.8801C140.755 69.3614 142.147 50.0614 139.805 50.1247L75.957 78.1572Z",
    fill: "#D33C3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.957 78.1568L139.805 50.1243C139.805 50.1243 72.793 24.3065 69.5658 24.3697C66.4651 24.433 0.528564 47.0869 0.528564 47.0869L75.957 78.1568Z",
    fill: "#E54242"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8516 36.3929L105.698 65.1215L107.09 86.7629C107.09 86.7629 116.835 87.7753 121.771 80.3717L120.569 58.6038L46.0893 31.647C46.0893 31.647 35.7116 31.7103 31.8516 36.3929Z",
    fill: "#FFAE1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1057 32.4694C93.1057 32.4694 103.547 32.2796 108.736 38.2911L44.3176 65.1213L44.0012 86.0034C44.0012 86.0034 29.7002 84.4214 25.5238 78.1568L26.0933 57.5911L93.1057 32.4694Z",
    fill: "#FFC91F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8687 47.0869C68.047 41.0754 92.3461 -20.5582 119.05 7.98057C147.335 38.1646 81.8418 55.1866 73.8687 47.0869ZM113.355 13.296C96.4592 -8.9149 74.628 44.1128 75.7038 45.505C77.349 47.7197 133.098 39.2403 113.355 13.296Z",
    fill: "#FFE424"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.961 11.4609C121.876 12.0094 121.813 12.5789 121.771 13.1695C121.075 17.9787 119.303 21.902 117.405 26.0151C117.025 27.9134 116.202 29.622 115 31.2672C114.684 31.8367 114.304 32.2797 113.861 32.5328C105.192 41.9614 83.867 45.9479 77.4758 45.8847C76.1469 46.0745 74.7548 46.1378 73.3627 46.201C73.4892 46.5385 73.658 46.8338 73.8689 47.087C81.5257 54.8703 142.337 39.4302 121.961 11.4609Z",
    fill: "#FFBB24"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5045 16.7762C78.3616 7.98047 78.1718 43.2268 74.0586 44.9986C68.5534 47.4032 39.5716 26.0782 59.5045 16.7762ZM73.4891 43.8596C74.3117 43.4166 73.9954 12.9162 61.2763 20.5097C46.4058 29.432 72.2235 44.6822 73.4891 43.8596Z",
    fill: "#FFE424"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4161 17.9155C57.3318 18.2108 57.2474 18.5061 57.163 18.8014C56.5302 21.3326 56.6568 23.6106 56.7833 26.0152C56.5935 27.0277 56.6568 28.0402 56.9099 29.0526C56.9521 29.3901 57.0575 29.6854 57.2263 29.9385C59.6309 36.2664 69.3758 42.4677 72.5398 43.67C73.1726 44.0497 73.8265 44.3872 74.5014 44.6825C74.3749 44.8091 74.2272 44.9145 74.0585 44.9989C68.743 47.3402 41.7863 27.6605 57.4161 17.9155Z",
    fill: "#FFBB24"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1307 7.85411C55.8344 -20.6847 80.1334 40.949 74.3118 46.9605C66.3387 55.0602 0.845005 38.0381 29.1307 7.85411ZM72.54 45.3785C73.5525 43.9864 51.7212 -9.04136 34.8258 13.1695C15.0828 39.1139 70.8947 47.6565 72.54 45.3785Z",
    fill: "#FFE424"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2199 11.3345C26.3043 11.8829 26.3886 12.4524 26.473 13.043C27.1058 17.8522 28.8776 21.7755 30.776 25.8886C31.1557 27.787 32.0416 29.4955 33.2438 31.1408C33.497 31.7103 33.8766 32.1532 34.3196 32.4063C42.9888 41.8982 64.3138 45.8215 70.705 45.7582C72.0338 45.948 73.426 46.0113 74.8181 46.0746C74.6915 46.4543 74.5228 46.7496 74.3118 46.9605C66.6551 54.7438 5.84409 39.3037 26.2199 11.3345Z",
    fill: "#FFBB24"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7672 46.3278C73.236 44.3661 79.3741 20.0037 90.8276 29.4323C102.977 39.4304 79.121 48.9855 75.7672 46.3278ZM88.9925 31.7103C81.5256 24.1802 75.8938 45.1887 76.3367 45.6317C77.096 46.391 97.6617 40.5061 88.9925 31.7103Z",
    fill: "#FFE424"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0932 30.5713C92.0932 30.8244 92.0932 31.0564 92.0932 31.2674C92.0932 33.1024 91.587 34.6844 91.0808 36.2664C91.0175 37.0257 90.8276 37.7218 90.448 38.3546C90.3636 38.6077 90.237 38.7975 90.0683 38.9241C87.284 42.9107 79.4374 45.4418 77.0328 45.6949C76.5266 45.8215 76.0204 45.927 75.5142 46.0113C75.5985 46.1379 75.6829 46.2434 75.7673 46.3277C78.9945 48.9222 101.142 40.1264 92.0932 30.5713Z",
    fill: "#FFBB24"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M37.1037 59.4265C41.8496 57.0852 46.7854 55.2501 51.8477 53.8579C54.189 53.2252 53.2398 49.555 50.8352 50.1878C45.4354 51.7065 40.2044 53.6892 35.142 56.136C32.9906 57.2117 34.8889 60.439 37.1037 59.4265Z",
    fill: "#FFE424"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M29.8899 63.9825C29.679 66.6824 29.4681 69.3823 29.2571 72.0822C29.1306 74.4868 32.9273 74.4868 33.0539 72.0822C33.2648 69.3823 33.4757 66.6824 33.6866 63.9825C33.8765 61.5147 30.0797 61.5779 29.8899 63.9825Z",
    fill: "#FFE424"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M93.7383 55.3764C99.4334 57.2748 105.129 59.1732 110.824 61.0715C113.165 61.8309 114.114 58.1607 111.836 57.4014C106.141 55.503 100.446 53.6046 94.7508 51.7063C92.4095 50.8836 91.4603 54.5538 93.7383 55.3764Z",
    fill: "#FFC91F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M114.304 64.1722C114.346 66.8299 114.304 69.5087 114.177 72.2086C113.987 74.6765 117.784 74.6132 117.974 72.2086C118.101 69.5087 118.143 66.8299 118.101 64.1722C118.037 61.7043 114.241 61.7043 114.304 64.1722Z",
    fill: "#FFC91F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M33.1805 125.996C33.2227 129.202 33.2438 132.408 33.2438 135.614C33.3071 138.019 37.1038 138.019 37.0406 135.614C37.0406 132.408 37.0195 129.202 36.9773 125.996C36.9773 123.591 33.1805 123.591 33.1805 125.996Z",
    fill: "#FFC91F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M33.1805 103.848C33.2227 109.079 33.2649 114.289 33.3071 119.478C33.3704 121.946 37.1671 121.946 37.1038 119.478C37.0617 114.289 37.0195 109.079 36.9773 103.848C36.9773 101.38 33.1805 101.38 33.1805 103.848Z",
    fill: "#FFC91F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M111.013 96.9509C110.845 104.502 110.781 112.032 110.824 119.541C110.824 122.009 114.62 122.009 114.62 119.541C114.578 112.032 114.641 104.502 114.81 96.9509C114.873 94.5463 111.077 94.5463 111.013 96.9509Z",
    fill: "#FFAE1F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M110.887 126.692C110.634 130.025 110.718 133.336 111.14 136.627C111.456 139.031 115.253 139.031 114.937 136.627C114.515 133.336 114.43 130.025 114.684 126.692C114.873 124.288 111.077 124.288 110.887 126.692Z",
    fill: "#FFAE1F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0704 49.2385C19.0061 47.7198 23.8997 46.0745 28.7511 44.3027C31.0291 43.4801 30.0167 39.8099 27.7386 40.6325C22.8872 42.4043 17.9937 44.0496 13.0579 45.5683C10.7166 46.2643 11.6658 49.9345 14.0704 49.2385Z",
    fill: "#EF4B4B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76731 78.6633C9.47201 87.6911 9.45093 96.7189 9.70405 105.747C9.76733 108.215 13.5641 108.215 13.5008 105.747C13.2477 96.7189 13.2687 87.6911 13.564 78.6633C13.6273 76.2587 9.83059 76.2587 9.76731 78.6633Z",
    fill: "#EF4B4B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95718 112.075C9.87281 115.112 9.85171 118.17 9.89389 121.25C9.95717 123.718 13.7539 123.718 13.6906 121.25C13.6484 118.17 13.6695 115.112 13.7539 112.075C13.8172 109.607 10.0205 109.607 9.95718 112.075Z",
    fill: "#EF4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrialpackGift);
export default __webpack_public_path__ + "static/media/trialpackGift.4df47282e003d31af58628b847e07d17.svg";
export { ForwardRef as ReactComponent };